// extracted by mini-css-extract-plugin
var _1 = "promo-module_promo__Fhb7vt";
var _2 = "promo-module_promoBody__JE642d";
var _3 = "promo-module_promoFrame__bbPjkn";
var _4 = "promo-module_promoLink__gafDOk";
var _5 = "promo-module_promoText__VLFxK5";
export { _1 as "promo", _2 as "promoBody", _3 as "promoFrame", _4 as "promoLink", _5 as "promoText" }
